import React, { useState, useEffect } from "react";
import {
  Backdrop,
  Button,
  DevNote,
  FormFieldSet,
  InfoTextAdv,
  LogoLoader,
  showToast,
  StatusTags,
  useFormHandler,
} from "../../../../components";
import { useNavigate, useLocation } from "react-router-dom";
import { v4 as uuid } from "uuid";
import {
  addChecklist,
  fetchOneChecklist,
  updateChecklist,
} from "../../../../redux/slices/onboarding/onboardingApi";
import {
  onboardingDocumentCategory,
  onboardingDocumentType,
} from "../../../../assets/data/enumData";
import { useLoginUser } from "../../../../hooks/useLoginUser";

const AddNewCheckList = () => {
  const location = useLocation();
  const checklistIdForEdit = location?.state?.checklistId;
  const checkListType = location?.state?.checkListType;
  console.log({ checkListType });
  const navigate = useNavigate();
  const isEdit = location.pathname.includes("editchecklist");
  const [editRowId, setEditRowId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const [tempApprover, setTempApprover] = useState({});
  const initialFormData = {
    id: uuid(),
    checklistName: "",
    description: "",
    checklists: [],
  };

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    initialFormData,
    {
      checklistName: { type: "text", required: true },
      description: { type: "text", required: true },
    }
  );

  const [rows, setRows] = useState([
    {
      id: uuid(),
      category: "",
      document: "",
      documentId: "",
      documentType: "",
      approver: [],
      checked: false,
    },
  ]);
  console.log({ rows });

  const handleRowCheckboxChange = (id) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, checked: !row.checked } : row
  );
  setRows(updatedRows);
};

const handleSelectAll = () => {
  const newCheckedState = !rows.every((r) => r.checked);
  const updatedRows = rows.map((row) => ({
    ...row,
    checked: newCheckedState,
  }));
  setRows(updatedRows);
};

const handleRowChange = (id, updatedFields) => {
  setRows((prevRows) =>
    prevRows.map((row) =>
      row.id === id ? { ...row, ...updatedFields } : row
    )
  );
};
  const handleAddRow = () => {
    const newRow = {
      id: uuid(),
      category: "",
      document: "",
      documentId: "",
      documentType: "",
      approver: "",
      checked: false,
    };
    setRows([...rows, newRow]);
  };

  const handleRemoveRow = (id) => {
    setRows((prev) => prev.filter((row) => row.id !== id));
  };

  const fetchCheckListOneAndPrefill = async (id) => {
    try {
      setIsLoading(true);
      const res = await fetchOneChecklist({
        uiid: id,
        ref: "Document",
        incl: ["name type category templateId _id"],
      });
      const checklistData = res?.data?.data || {};
      console.log({ checklistData }, "EDITING CHECKLIST");
      handleChange("checklistName", checklistData?.name || "");
      handleChange("description", checklistData?.description || "");
      setRows(
        checklistData?.documents?.map((data) => ({
          id: data._id,
          category: data?.id?.category,
          document: { label: data?.id?.name, value: data?.id?.uiid },
          documentId: data?.id?.templateId,
          documentType: data?.id?.type,
          approver: data?.approver || [],
        })) || []
      );
    } catch (error) {
      console.error("Error in fetchCheckListOneAndPrefill", error, { id });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (checklistIdForEdit) {
      fetchCheckListOneAndPrefill(checklistIdForEdit);
    }
  }, [checklistIdForEdit]);

  const handleSave = async () => {
    try {
      const isValid = validateAllFields();
      if (!isValid) {
        showToast("All mandatory fields must be filled out.", "error");
        return;
      }
      if (!checklistIdForEdit) {
        const hasAtLeastOneValidRow = rows?.some((row) => row?.document?.value);

        if (!hasAtLeastOneValidRow) {
          showToast("Atleast one checklist to be added", "error");
          return;
        }
        const createPayload = {
          name: formData?.checklistName || "",
          description: formData?.description || "",
          entity: checkListType,
          documents: rows?.map((data) => ({
            id: data?.document?.value || null,
            approver: data.approver,
          })),
          addedBy: loginUserUiid,
        };
        if (createPayload?.filter) console.log({ createPayload });
        const res = await addChecklist(createPayload);
        console.log({ res });
        if (res.success) {
          showToast("Checklist Added Successfully", "success");
          navigate(-1);
        } else {
          showToast("Something Went Wrong", "error");
        }
      } else {
        console.log({ rows }, "rows in update");
        const updatePayload = [
          {
            type: "SET",
            value: {
              _skipFlatten: ["documents"],
              name: formData?.checklistName || "",
              description: formData?.description || "",
              entity: checkListType,
              documents: rows?.map((data) => ({
                id: data?.document?.value ?? data?.document,
                approver: data.approver,
              })),
            },
          },
        ];
        const res = await updateChecklist({
          coll: "Checklist",
          uiid: checklistIdForEdit,
          payload: updatePayload,
        });
        console.log({ res });
        if (res.success) {
          showToast("Checklist Updated Successfully", "success");
          navigate(-1);
        } else {
          showToast("Something Went Wrong", "error");
        }
      }
    } catch (e) {
      console.error(
        `Error in handleSave for checkListType ${checkListType}`,
        e
      );
    }
  };

  const headers = [
    { label: "", span: 1 },
    { label: "Document Category", span: 2 },
    { label: "Choose Document", span: 2 },
    { label: "Document ID", span: 2 },
    { label: "Document Type", span: 2 },
    { label: "Approvers", span: 3 },
  ];

  const allChecked = rows.length > 0 && rows.every((r) => r.checked);

  return (
    <div className="mr-2">
      <DevNote>
        <div>{checklistIdForEdit ? "Edit Mode" : "Add Mode"}</div>
        <div>
          {checkListType === 1
            ? "Applicant Checklists"
            : checkListType === 2
            ? "Vendor Checklists"
            : checkListType === 3
            ? "Client Checklists"
            : ""}
        </div>
      </DevNote>

      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Button
          variant="text"
          icon={"west"}
          color="secondary"
          title={isEdit ? "Edit Checklist" : "Add Checklist"}
          className="font-semibold text-black !px-1"
          onClick={() => navigate("/e-onboarding/checklist")}
        />
      </div>

      <div className="grid grid-cols-3 xl:grid-cols-4 gap-5 items-center pb-5 pt-2">
        <FormFieldSet
          type="text"
          title="Checklist Name"
          placeholder="Enter Checklist Name"
          value={formData.checklistName}
          onChange={(value) => handleChange("checklistName", value)}
          error={errors.checklistName}
        />
        <FormFieldSet
          type="text"
          title="Description"
          placeholder="Enter"
          value={formData.description}
          onChange={(value) => handleChange("description", value)}
          error={errors.description}
        />
      </div>

      <div className="border border-gray-200 rounded-md overflow-x-auto">
        <div className="min-w-[1200px]">
          <div className="grid grid-cols-12 gap-3 items-center font-medium text-md p-2 border-gray-200 bg-[#FFFCFA] shadow-sm">
            {headers.map((header, index) => (
              <div
                key={index}
                className={`col-span-${header.span} ${
                  header.label === "" ? "flex justify-center items-center" : ""
                }`}
              >
                {header.label === "" ? (
                  <FormFieldSet
                    noTitle
                    type="checkbox"
                    options={[{ label: "", value: "all" }]}
                    values={allChecked ? ["all"] : []}
                    onChange={handleSelectAll}
                    multiple
                  />
                ) : (
                  <h6 className="text-sm">{header.label}</h6>
                )}
              </div>
            ))}
          </div>

          {/* Table Rows */}
          <div>
            {rows.map((row, idx) => (
              <div
                key={idx}
                className="grid grid-cols-12 gap-3 items-center p-2 shadow-md"
              >
                <div className="col-span-1 flex justify-center items-center">
                  <FormFieldSet
                    type="checkbox"
                    noTitle
                    options={[{ label: "", value: row.id }]}
                    values={row.checked ? [row.id] : []}
                    multiple
                    onChange={() => handleRowCheckboxChange(row.id)}
                  />
                </div>

                <div className="col-span-2">
                  <FormFieldSet
                    type="select"
                    placeholder="Select"
                    noTitle
                    options={onboardingDocumentCategory}
                    value={row.category}
                    onChange={(value) =>
                      handleRowChange(row.id, { category: value })
                    }
                  />
                </div>

                {/* Document */}
                <div className="col-span-2">
                  <FormFieldSet
                    type="allPdfTemplatesNames"
                    // type="select"
                    placeholder="Select"
                    noTitle
                    // options={[
                    //   { label: "Driving License", value: "Driving License" },
                    //   { label: "Passport", value: "Passport" },
                    //   { label: "H1b", value: "H1b" },
                    // ]}
                    value={row.document}
                    disabled={!row.category}
                    onChange={(value) => {
                      handleRowChange(row.id, {
                        category: value?.data?.category || "",
                        document: value,
                        documentId: value?.data?.templateId || "",
                        documentType: value?.data?.type || "",
                      });
                    }}
                    showSearch
                    filters={{ category: row.category, entity: checkListType }}
                  />
                </div>

                <div className="col-span-2">
                  <FormFieldSet
                    type="text"
                    placeholder="Enter"
                    noTitle
                    value={row.documentId}
                    // onChange={(value) =>
                    //   handleRowChange(row.id, "documentId", value)
                    // }
                    disabled
                  />
                </div>

                <div className="col-span-2">
                  <FormFieldSet
                    type="select"
                    placeholder="Select"
                    noTitle
                    disabled={true}
                    options={onboardingDocumentType}
                    value={row.documentType}
                    // onChange={(value) =>
                    //   handleRowChange(row.id, "documentType", value)
                    // }
                  />
                </div>

                <div className="col-span-2 mb-2">
                  {(() => {
                    const tempValue =
                      tempApprover[row.id] ?? row.approver ?? [];
                    const isRowEditing = editRowId.includes(row.id);
                    const isValueChanged =
                      JSON.stringify(tempValue) !==
                      JSON.stringify(row.approver);

                    if (isEdit && (isRowEditing || !row.approver?.length)) {
                      return (
                        <div className="flex gap-2 items-center mt-2">
                          <div className="w-[300px] overflow-auto">
                            <FormFieldSet
                              type="usersForEonboarding"
                              noTitle
                              placeholder="Select"
                              multiple
                              value={tempValue}
                              onChange={(newValue) => {
                                setTempApprover((prev) => ({
                                  ...prev,
                                  [row.id]: newValue,
                                }));
                              }}
                              // options={[
                              //   { label: "Vikranth", value: 1 },
                              //   { label: "Abdul Samad", value: 2 },
                              // ]}
                            />
                          </div>

                          <Button
                            color="black"
                            type="icon"
                            size="sm"
                            variant="text"
                            icon="save"
                            disabled={!isValueChanged}
                            onClick={() => {
                              handleRowChange(row.id, {
                                approver: tempValue,
                              });

                              setTempApprover((prev) => {
                                const updated = { ...prev };
                                delete updated[row.id];
                                return updated;
                              });

                              setEditRowId((prev) =>
                                prev.filter((id) => id !== row.id)
                              );
                            }}
                          />
                        </div>
                      );
                    }

                    if (isEdit) {
                      return (
                        <div className="flex gap-2 items-center">
                          <StatusTags
                            tag="Approvers configured"
                            className="text-success mt-2"
                            variant="text"
                          />
                          <Button
                            color="black"
                            type="icon"
                            size="sm"
                            variant="text"
                            icon="edit_square"
                            className="mt-2"
                            onClick={() =>
                              setEditRowId((prev) =>
                                prev.includes(row.id) ? prev : [...prev, row.id]
                              )
                            }
                          />
                        </div>
                      );
                    }
                    return (
                      <div className="w-full max-w-[300px] overflow-auto mt-2">

                        <FormFieldSet
                          type="usersForEonboarding"
                          placeholder="Select"
                          noTitle
                          multiple
                          value={row.approver}
                          onChange={(value) =>
                            handleRowChange(row.id, { approver: value })
                          }
                          // options={[
                          //   { label: "Vikranth", value: 1 },
                          //   { label: "Abdul Samad", value: 2 },
                          // ]}
                        />
                      </div>
                    );
                  })()}
                </div>

                {/* <div className="flex"> */}
                <div className="col-span-1 items-center">
                  <div className=" flex gap-2">
                    <Button
                      type="icon"
                      icon="add"
                      size="xs"
                      color="black"
                      disabled={rows.length >= 5}
                      onClick={handleAddRow}
                    />
                    <Button
                      type="icon"
                      icon="remove"
                      size="xs"
                      color="danger"
                      disabled={rows.length === 1}
                      onClick={() => handleRemoveRow(row.id)}
                    />
                  </div>
                </div>
                {/* </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-4 mt-6">
        <Button
          title="Cancel"
          variant="outlined"
          onClick={() => navigate(-1)}
        />
        <Button title="Save" onClick={handleSave} />
      </div>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AddNewCheckList;
